import { Add } from "@mui/icons-material";
import { Card, Typography } from "@mui/material";
import TicketFilters from "./TicketFilters";
import { ListDivider } from "../../../ui/ListStyles";
import TicketsList from "./TicketsList";
import { Link } from "react-router-dom";

const TicketBar = () => {
  return (
    <Card
      sx={{
        height: "88vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: "20px",
      }}
    >
      <Typography sx={{ fontSize: "20px" }}>تیکت های اخیر</Typography>

      {/* filters  */}
      <TicketFilters />

      <ListDivider flexItem />

      <Link className="btn btn-softblue" style={{ fontSize: "14px" }}>
        تیکت جدید
        <Add sx={{ width: "18px" }} />
      </Link>

      <ListDivider flexItem />

      {/* tickets */}
      <TicketsList />
    </Card>
  );
};

export default TicketBar;
